import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { FC, memo } from 'react';

type Props = {
  open: boolean;
  message: string;
  okLabel: string;
  onOk: () => void;
  onCancel: () => void;
};

export const DeleteConfirmDialog: FC<Props> = memo(({ open, message, okLabel, onOk, onCancel }) => (
  <Dialog open={open} maxWidth="xs" sx={{ '& .MuiDialog-paper': { width: '80%' } }}>
    <DialogContent dividers>
      <Typography sx={{ whiteSpace: 'pre-wrap' }}>{message}</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>キャンセル</Button>
      <Button color="error" onClick={onOk}>{okLabel}</Button>
    </DialogActions>
  </Dialog>
));
